import { colors } from '@shared/tokens/colors.stylex';
import { FC } from 'react';

interface DocumentProps {
  color?: string;
}

export const DocumentIcon: FC<DocumentProps> = ({ color = colors.tertiaryIcon }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.6875 2.5C4.51491 2.5 4.375 2.63991 4.375 2.8125V17.1875C4.375 17.3601 4.51491 17.5 4.6875 17.5H15.3125C15.4851 17.5 15.625 17.3601 15.625 17.1875V9.6875C15.625 8.47938 14.6456 7.5 13.4375 7.5H12.1875C11.3246 7.5 10.625 6.80044 10.625 5.9375V4.6875C10.625 3.47938 9.64562 2.5 8.4375 2.5H4.6875ZM4.6875 1.25C3.82456 1.25 3.125 1.94955 3.125 2.8125V17.1875C3.125 18.0504 3.82455 18.75 4.6875 18.75H15.3125C16.1754 18.75 16.875 18.0504 16.875 17.1875V9.375C16.875 4.88769 13.2373 1.25 8.75 1.25H4.6875ZM11.4642 3.05654C11.7263 3.54183 11.875 4.09729 11.875 4.6875V5.9375C11.875 6.11009 12.0149 6.25 12.1875 6.25H13.4375C14.0277 6.25 14.5832 6.39875 15.0685 6.6608C14.374 5.04624 13.0788 3.75102 11.4642 3.05654Z"
        fill={color}
      />
    </svg>
  );
};
